import React from 'react'
import PropTypes from 'prop-types'
import { sizes, useTheme } from '@qflow/theme'

export function Announcement({ size = sizes.SMALL, colour, ...props }) {
  const theme = useTheme()

  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 36 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33 3.65703V27.1421L3 16.6794V14.0941L33 3.65703ZM0.537611 18.4846C0.206495 18.0349 0.0190914 17.4956 0 16.9374V13.919C0.00228048 13.3465 0.181911 12.7889 0.514173 12.3227C0.846435 11.8565 1.315 11.5048 1.85538 11.3159L34.1723 0.0728196C34.3798 0.0027345 34.6009 -0.0171367 34.8176 0.0148378C35.0342 0.0468123 35.2402 0.129721 35.4186 0.256754C35.597 0.383788 35.7427 0.551324 35.8438 0.745604C35.9448 0.939884 35.9984 1.15537 36 1.37436V29.4267C35.9984 29.6457 35.9448 29.8611 35.8438 30.0554C35.7427 30.2497 35.597 30.4172 35.4186 30.5443C35.2402 30.6713 35.0342 30.7542 34.8176 30.7862C34.6009 30.8182 34.3798 30.7983 34.1723 30.7282L1.85538 19.4574C1.32808 19.2735 0.868728 18.9344 0.537611 18.4846ZM19.1203 26.2134C19.1467 25.9955 19.1958 25.786 19.265 25.5868L22.0985 26.5744C21.8653 28.4979 20.9077 30.2603 19.4206 31.5026C17.9335 32.7448 16.0289 33.3735 14.0945 33.2605C12.1601 33.1475 10.3415 32.3015 9.00915 30.8946C7.67676 29.4877 6.93076 27.6259 6.9231 25.6882V21.2851L9.9231 22.3307V25.6816C9.92906 26.854 10.381 27.9803 11.1873 28.8317C11.9949 29.6844 13.097 30.1971 14.2694 30.2656C15.4417 30.3341 16.5961 29.9531 17.4973 29.2002C18.3986 28.4473 18.979 27.3792 19.1203 26.2134Z"
        fill={colour || theme.secondary.fg}
      />
    </svg>
  )
}

Announcement.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
